module.exports = __webpack_public_path__ + "static/media/add_fund.e2e35109.svg";